<template>
    <div v-if="!$store.state.isMobile" :class="{topMenu:true,in:flag,out:!flag,halfWidth:isHalfClass}"
         @mouseleave="miceLeave">
        <div :class="{menu:true,white:flag,black:!flag}">
            <!--            <div class="navListHome" v-if="!isLogin && isHome">-->
            <!--                &lt;!&ndash;            <div class="navList" v-if="true">&ndash;&gt;-->
            <!--                <div class="nav" @click="goBlock('offre')">-->
            <!--                    {{ langPage['v4-menu-not-connected']['TXT_offre'].toUpperCase() }}-->
            <!--                </div>-->
            <!--                <div class="nav" @click="goBlock('categories')">-->
            <!--                    {{ langPage['v4-menu-not-connected']['TXT_categories'].toUpperCase() }}-->
            <!--                </div>-->
            <!--                <div class="nav" @click="goBlock('chiffres')">-->
            <!--                    {{ langPage['v4-menu-not-connected']['TXT_chiffre'].toUpperCase() }}-->
            <!--                </div>-->
            <!--                <div class="nav" @click="goBlock('comment')">-->
            <!--                    {{ langPage['v4-menu-not-connected']['TXT_avis'].toUpperCase() }}-->
            <!--                </div>-->
            <!--                <div class="nav" @click="goBlock('avis')">-->
            <!--                    {{ langPage['v4-menu-not-connected']['TXT_commentcamarche'].toUpperCase() }}-->
            <!--                </div>-->
            <!--                <div class="nav" @click="$router.push('productList')">-->
            <!--                    {{ $t('topMenuNoLogin.preview catalog').toUpperCase() }}-->
            <!--                </div>-->
            <!--            </div>-->
            <div class="navList">
                <div v-for="(cate,cateKey) in menu" @click="categorys(cateKey,cate)" :key="'menu'+cateKey"
                     :class="{nav:true,act:cateKey == category}" style="font-weight: bold;" @mouseenter="miceLeave">
                    {{ cateKey.toUpperCase() }}
                </div>
            </div>
            <div class="navList" v-if="!isLogin" style="text-align: right">
                <!--                <div class="nav">-->
                <!--                    <router-link to="/sign/signpage/seller">-->
                <!--                        {{langPage['v4-menu-not-connected']['TXT_devenirvendeur']}}-->
                <!--                    </router-link>-->
                <!--                </div>-->
                <div class="nav">
                    <p @click="$router.push('/sign')">{{ langPage['v4-menu-not-connected']['TXT_sinscrire'] }}</p>
                </div>
                <div class="nav">
                    <p @click="onClickLogin">{{
                            langPage['v4-menu-not-connected']['TXT_login']
                        }}
                    </p>
                </div>
                <div class="nav">
                    <el-dropdown trigger="click" class="lang" @command="langChang">
                      <span class="el-dropdown-link">
                        {{ lang_text }}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="fr">FR</el-dropdown-item>
                            <el-dropdown-item command="en">EN</el-dropdown-item>
                            <el-dropdown-item command="es">ES</el-dropdown-item>
                            <el-dropdown-item command="it">IT</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class="navList" v-else style="text-align: right">
                <div class="nav">
                    <el-dropdown class="lang" trigger="click" @command="langChang">
                      <span class="el-dropdown-link">
                        {{ lang_text }}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="fr">FR</el-dropdown-item>
                            <el-dropdown-item command="en">EN</el-dropdown-item>
                            <el-dropdown-item command="es">ES</el-dropdown-item>
                            <el-dropdown-item command="it">IT</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="nav" @click="toFavoris">
                    <img class="icon" v-if="flag" src="@/assets/img/topMenu/Coeur.svg" alt="">
                    <img class="icon" v-else src="@/assets/img/topMenu/Coeur.svg" alt="">
                    <div class="num" v-if="notifyDataCount.fav_products_count">
                        {{ notifyDataCount.fav_products_count > 99 ? '...' : notifyDataCount.fav_products_count }}
                    </div>
                </div>

                <el-dropdown trigger="click" class="lang" @command="langChang">
                    <div class="nav" style="margin-right: 25px">
                        <img class="icon" v-if="flag" src="@/assets/img/topMenu/mine_w.svg" alt="">
                        <img class="icon" v-else src="@/assets/img/topMenu/mine.svg" alt="">
                        <!--                    <div class="num" v-if="notifyDataCount.useful_order_count">-->
                        <!--                        {{notifyDataCount.useful_order_count > 99 ? '...': notifyDataCount.useful_order_count}}-->
                        <!--                    </div>-->
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="maxPayment" @click.native="$router.push('/help/?keyword=hero')">
                            <p>{{ `montant disponible:${maxPayment.delCurrent} €` }}</p>
                            <p>{{ `paiement à 30 jours:${maxPayment.maxPay30D} € ` }}</p>
                            <p>{{ `paiement en 3 fois:${maxPayment.maxPay3X} € ` }}</p>
                            <p>(Voir les conditions)</p>
                        </el-dropdown-item>
                        <el-dropdown-item v-for="(itemRouter,index) of personRouterlist"
                                          :key="index"
                                          @click.native="onPersonMenuItemClick(itemRouter)">
                            {{ itemRouter.name[0] }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <div class="nav" @click="toPanier">
                    <img class="icon" v-if="flag" src="@/assets/img/topMenu/Bag_w.svg" alt="">
                    <img class="icon" v-else src="@/assets/img/topMenu/Bag.svg" alt="">
                    <div class="num" v-if="notifyDataCount.car_order_count">
                        {{ notifyDataCount.car_order_count > 99 ? '...' : notifyDataCount.car_order_count }}
                    </div>
                </div>
            </div>
            <img class="logo" v-if="flag" src="@/assets/img/topMenu/topLogo_w.svg" alt=""
                 style="cursor: pointer" @click="onTopLogoClick()">
            <img class="logo" v-if="!flag" src="@/assets/img/topMenu/topLogo.svg" alt=""
                 style="cursor: pointer" @click="onTopLogoClick()">
            <div class="navList typeList"
                 style="display: inline-flex;flex-wrap: wrap;width: 100%;position: relative;margin-top: 20px"
                 v-if="Object.keys(menu).length>0">
                <div class="nav child" v-for="(type_sub_menu,typeKey) in menu[category]['sub_menu']"
                     :key="typeKey" @mouseenter="miceOver(typeKey)">
                    <div v-if="Object.keys(type_sub_menu).length>0" :class="{childs:true}"
                         @click="categoryMenuClick(typeKey)">
                        {{ getTopMenuDesc(typeKey) }}
                    </div>
                </div>
                <div class="searchContainer">
                    <el-select v-model="search_category" :placeholder="langPage['filtres-grossiste']['TXT_Categorie']"
                               class="selectBox">
                        <el-option
                            v-for="item in search_categories"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <my-autocomplete class="search" v-model="keywords" v-on:keyup.native.enter="kwSearch"
                                     :placeholder="langPage['v4-topmenu']['TXT_rechercherunproduit']"
                                     :triggerOnFocus="false"
                                     :triggerOnChange="false"
                                     :fetch-suggestions="kwSearch" @select="handleSelect" @showAll="showAll">
                    </my-autocomplete>
                </div>
            </div>
            <p class="shadow"
               v-if="$store.state.token && !['help','about','result'].includes($route.path.substring($route.path.lastIndexOf('/') + 1))"></p>

        </div>
        <div class="listMenu" v-if="hoverFlag ">
            <!-- <div class="list" v-for="(linkType,linkKey) in menu[category]['sub_menu']" :key="linkKey"> -->
            <div class="menuCont" v-if="Object.keys(menu).length>0">
                <template v-if="type==='Nouveautés' || type==='Marques'">
                    <div v-for="(items,itemkeys) in menu[category]['sub_menu'][type]" :key="itemkeys">
                        <div class="menuItem">
                            <div class="menuItem_li">
                                <div v-if="itemkeys!='PUSH' && type==='Nouveautés'" class="noPush">
                                    <p>{{ getTopMenuDesc(itemkeys) }}</p>
                                    <div class="itembtn" v-for="(itembtn,itembtnKey) in items" :key="itembtnKey"
                                         style="cursor: pointer" @click="onMenuChildClick(itembtn,null
                                         ,'newModel',{parentTypeKey:itemkeys})">
                                        {{ getTopMenuDesc(itembtnKey) }}
                                    </div>
                                    <p class="tout" @click="onClickNewSeeMore(itemkeys)">
                                        {{ langPage['home']['TXT_modnvvoirtout'] }}</p>
                                </div>
                                <div v-if="type==='Marques'" class="noPush Marque">
                                    <template v-if="itemkeys !== 'AUTRES'">
                                        <p>{{ itemkeys }}</p>
                                        <div v-for="(itemImg,itemImgKey) in items" :key="itemImgKey" class="imgs">
                                            <el-image :lazy='true' :src="itemImg.logo_url" alt
                                                      class="img2"
                                                      @click="onMenuChildClick(null,itemImg.id_vendeur,'seller')"
                                            >
                                                <div slot="error" style="text-align: center;margin-top: 40px">
                                                    <span
                                                        @click="onMenuChildClick(null,itemImg.id_vendeur,'seller')"
                                                    >{{ itemImgKey }}</span>
                                                </div>
                                            </el-image>
                                        </div>
                                    </template>
                                    <template v-if="itemkeys === 'AUTRES'">
                                        <p class="autres-right">{{ itemkeys }}</p>
                                        <div class="itembtn autres" v-for="(itembtn,itembtnKey) in items"
                                             :key="itembtnKey" style="cursor: pointer"
                                             @click="onMenuChildClick(null,itembtn,'seller')">
                                            <span>{{ itembtnKey }}</span>
                                        </div>
                                    </template>
                                    <p class="tout" v-if="itemkeys === 'AUTRES'"
                                       @click="$router.push({path:'/MarquesList'})">
                                        {{ langPage['home']['TXT_modnvvoirtout'] }}</p>
                                </div>
                                <div v-if="itemkeys == 'PUSH'" class="isPush">
                                    <div v-for="(pushbtn,pushbtnKey) in items" :key="pushbtnKey">
                                        <img v-lazy="pushbtn.img_url" alt="" class="nouv-img"
                                             style="width: 15vw;height: 21vw;object-fit: cover;cursor: pointer"
                                             @click="onMenuPushImgClick(pushbtn)">
                                        <p>{{ pushbtnKey }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="type==='Vêtements'">
                    <div v-for="(vetem,itemkeys) in menu[category]['sub_menu'][type].sub_categorie" :key="itemkeys">
                        <div class="noPush">
                            <div class="vetem">
                                <p style="cursor: pointer"
                                   @click="onMenuChildClick(menu[category]['sub_menu'][type].id_categorie,vetem.id_categorie)">
                                    {{ vetem.libelle }}</p>
                                <div class="itembtn" v-for="(VetemChilds,childsKey) in vetem.sub_categorie"
                                     :key="childsKey" style="cursor: pointer"
                                     @click="onMenuChildClick(menu[category]['sub_menu'][type].id_categorie,VetemChilds.id_categorie)">
                                    {{ VetemChilds.libelle }}
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="type==='Accessoires'">
                    <div v-for="(vetem,itemkeys) in menu[category]['sub_menu'][type]" :key="itemkeys">
                        <div class="noPush">
                            <div class="vetem">
                                <p style="cursor: pointer"
                                   @click="onMenuChildClick(menu[category]['sub_menu'][type].id_categorie,vetem.id_categorie)">
                                    {{ vetem.libelle }}</p>
                                <div class="itembtn" v-for="(VetemChilds,childsKey) in vetem.sub_categorie"
                                     :key="childsKey" style="cursor: pointer"
                                     @click="onMenuChildClick(menu[category]['sub_menu'][type].id_categorie,VetemChilds.id_categorie)">
                                    {{ VetemChilds.libelle }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vetem-push" v-if="type==='Accessoires'">
                        <img src="../assets/source/push/Acces_img.png" alt=""
                             style="width: 15vw;height: 21vw;object-fit: cover">
                        <p>AUTOMNE</p>
                    </div>
                </template>
                <template v-if="type==='Outlet'">
                    <div class="topOutlet">
                        <div class="vetem leftContainer">
                            <p>{{ $t("topMenuOutlet.word1") }}</p>
                            <div @click="onClickOutletRemise({prix_debut:0,prix_fin:5})">
                                {{ $t("topMenuOutlet.word2") }}
                            </div>
                            <div @click="onClickOutletRemise({prix_debut:5,prix_fin:10})">
                                {{ $t("topMenuOutlet.word3") }}
                            </div>
                            <div @click="onClickOutletRemise({prix_debut:10,prix_fin:15})">
                                {{ $t("topMenuOutlet.word4") }}
                            </div>
                            <p>{{ $t("topMenuOutlet.word5") }}</p>
                            <div @click="onClickOutletRemise({promotion_debut:0,promotion_fin:30})">
                                {{ $t("topMenuOutlet.word6") }}
                            </div>
                            <div @click="onClickOutletRemise({promotion_debut:30,promotion_fin:50})">
                                {{ $t("topMenuOutlet.word7") }}
                            </div>
                            <div @click="onClickOutletRemise({promotion_debut:50,promotion_fin:100})">
                                {{ $t("topMenuOutlet.word8") }}
                            </div>
                            <p>{{ $t("topMenuOutlet.word9") }}</p>
                            <p>{{ $t("topMenuOutlet.word10") }}</p>
                        </div>
                        <div class="vetem rightContainer">
                            <p>{{ $t("topMenuOutlet.word11") }}</p>
                            <div @click="onClickOutletRemise({type:11,promotion_debut:0,promotion_fin:100})">
                                {{ $t("topMenuOutlet.word12") }}
                            </div>
                            <div @click="onClickOutletRemise({type:1103,promotion_debut:0,promotion_fin:100})">
                                {{ $t("topMenuOutlet.word13") }}
                            </div>
                            <div @click="onClickOutletRemise({type:14,promotion_debut:0,promotion_fin:100})">
                                {{ $t("topMenuOutlet.word14") }}
                            </div>
                            <div @click="onClickOutletRemise({type:15,promotion_debut:0,promotion_fin:100})">
                                {{ $t("topMenuOutlet.word15") }}
                            </div>
                            <div @click="onClickOutletRemise({type:11,promotion_debut:0,promotion_fin:100})">
                                {{ $t("topMenuOutlet.word16") }}
                            </div>
                        </div>
                        <div style="position: absolute;right: 20vw">
                            <FillBgBox class="bg1"
                                       :bg-img="imgs.bg1"
                                       :imgData="{jumpUrl:'/productList?prix_fin=5'}">
                                <div>
                                    <p>{{ $t("topMenuOutlet.word17") }}</p>
                                    <span>{{ $t("topMenuOutlet.word18") }}</span>
                                </div>
                            </FillBgBox>
                            <div style="font-size: 14pt;margin-top: 0.5vw">{{ $t("topMenuOutlet.word19") }}</div>
                        </div>
                        <div style="position: absolute;right: 0">
                            <FillBgBox class="bg2"
                                       :bg-img="imgs.bg2"
                                       :imgData="{jumpUrl:'/productList?prix_fin=5'}">
                                <div>
                                    <p>{{ $t("topMenuOutlet.word17") }}</p>
                                    <span>{{ $t("topMenuOutlet.word18") }}</span>
                                </div>
                            </FillBgBox>
                            <div style="font-size: 14pt;margin-top: 0.5vw">{{ $t("topMenuOutlet.word19") }}</div>
                        </div>
                    </div>
                </template>
            </div>
            <!-- </div> -->
        </div>
        <el-dialog :visible.sync="isShowLoginDialog" :modal-append-to-body='false' :show-close="false"
                   :custom-class="'elDialog'">
            <Login :is_dialog="true"/>
        </el-dialog>
    </div>
    <div v-else :class="{mTopMenu:true,in:flag,out:!flag}" @mouseleave="miceLeave">
        <el-row type="flex" align="middle" class="content">
            <img :src="mMenuFlag!==0?require(`@/assets/img/cha.png`):require(`@/assets/img/mobile/menu.svg`)"
                 class="leftMenu" alt="" @click="onClickMenuOrCloseBtn()"/>
            <div class="flexGrow1"></div>
            <img src="@/assets/img/topMenu/topLogo.svg" class="centerLogoIcon" alt="" @click="onTopLogoClick()"/>

            <el-row v-if="isLogin" class="rightMenu" type="flex" align="middle">
                <img src="@/assets/img/topMenu/search.svg" class="rightSearch" alt=""
                     @click="mMenuFlag=mMenuFlag===2?0:2"/>
                <img src="@/assets/img/topMenu/Bag.svg" class="rightShopCar" alt="" @click="$router.push('/panier')"/>

            </el-row>
            <el-row v-if="!isLogin" class="rightMenu" type="flex" align="middle">
                <img class="icon" src="@/assets/img/mobile/mine_login.svg" alt="" @click="onClickLogin">
                <el-dropdown class="lang" trigger="click" style="margin-right: 2vw;" @command="langChang">
                      <span class="el-dropdown-link" style="display: flex">
                        {{ lang_text }}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="fr">FR</el-dropdown-item>
                        <el-dropdown-item command="en">EN</el-dropdown-item>
                        <el-dropdown-item command="es">ES</el-dropdown-item>
                        <el-dropdown-item command="it">IT</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-row>

        </el-row>
        <div v-if="mMenuFlag===1" class="menuDetailContainer topMenuCollapse">
            <div class="navList" v-if="isLogin&&Object.keys(menu).length>0">
                <div v-for="(cate,cateKey) in menu" @click="categorys(cateKey,cate)" :key="'menu'+cateKey"
                     :class="{nav:true,act:cateKey == category}" style="font-weight: bold;" @mouseenter="miceLeave">
                    {{ cateKey }}
                </div>
            </div>

            <div v-if="Object.keys(menu).length>0">
                <div v-if="mobile_menu_item_type_name==null">
                    <div v-for="(type1,typeKey) in menu[category]['sub_menu']"
                         :key="typeKey" @click="onClickMobileMenuSubTitle(typeKey)">
                        <div class="collapseTopMenu">
                            <div class="flexGrow1 title">{{ getTopMenuDesc(typeKey) }}</div>
                            <i class="el-collapse-item__arrow el-icon-arrow-right"></i>
                        </div>
                        <el-divider/>
                    </div>
                </div>
                <div v-else>
                    <div class="subMenuBox" @click="mobile_menu_item_type_name=null">
                        <i class="el-collapse-item__arrow el-icon-arrow-left"
                           v-if="mobile_menu_item_type_name!='Marques'"></i>
                        <span>{{ getTopMenuDesc(mobile_menu_item_type_name) }}</span>
                    </div>
                    <div v-if="mobile_menu_item_type_name==='Vêtements'">
                        <el-collapse class="collapseMenu"
                                     v-for="(items,itemkeys) in menu[category]['sub_menu'][mobile_menu_item_type_name]['sub_categorie']"
                                     :key="itemkeys" accordion style="">
                            <el-collapse-item :title="items.libelle" :name="1">
                                <p class="itembtn" v-for="(itembtn,itembtnKey) in items['sub_categorie']"
                                   :key="itembtnKey"
                                   style="cursor: pointer;font-size: 14px"
                                   @click="onMenuChildClick(menu[category]['sub_menu'][mobile_menu_item_type_name].id_categorie,itembtn.id_categorie)">
                                    {{ getTopMenuDesc(itembtn.libelle) }}
                                </p>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                    <div v-if="mobile_menu_item_type_name==='Accessoires'">
                        <el-collapse class="collapseMenu"
                                     v-for="(items,itemkeys) in menu[category]['sub_menu'][mobile_menu_item_type_name]"
                                     :key="itemkeys" accordion style="padding: 2vw">
                            <el-collapse-item :title="items.libelle" :name="1">
                                <p class="itembtn" v-for="(itembtn,itembtnKey) in items['sub_categorie']"
                                   :key="itembtnKey"
                                   style="cursor: pointer;font-size: 14px"
                                   @click="onMenuChildClick(menu[category]['sub_menu'][mobile_menu_item_type_name].id_categorie,itembtn.id_categorie)">
                                    {{ getTopMenuDesc(itembtn.libelle) }}
                                </p>
                            </el-collapse-item>
                        </el-collapse>
                    </div>

                    <div v-if="mobile_menu_item_type_name==='Nouveautés' || mobile_menu_item_type_name==='Marques'">
                        <div v-for="(items,itemkeys) in menu[category]['sub_menu'][mobile_menu_item_type_name]"
                             :key="itemkeys">
                            <div class="menuItem">
                                <div class="menuItem_li">
                                    <div v-if="itemkeys!='PUSH' && mobile_menu_item_type_name==='Nouveautés'"
                                         class="noPush">
                                        <p>{{ getTopMenuDesc(itemkeys) }}</p>
                                        <div class="itembtn" v-for="(itembtn,itembtnKey) in items" :key="itembtnKey"
                                             style="cursor: pointer" @click="onMenuChildClick(itembtn,null
                                         ,'newModel',{parentTypeKey:itemkeys})">
                                            {{ getTopMenuDesc(itembtnKey) }}
                                        </div>
                                    </div>
                                    <div v-if="mobile_menu_item_type_name==='Marques'" class="noPush Marque">
                                        <template v-if="itemkeys !== 'AUTRES'">
                                            <p>{{ getTopMenuDesc(itemkeys) }}</p>
                                            <div class="imgsBox">
                                                <div v-for="(itemImg,itemImgKey) in items" :key="itemImgKey"
                                                     class="imgs">
                                                    <el-image :lazy='true' :src="itemImg.logo_url" alt
                                                              class="img2"
                                                              @click="onMenuChildClick(null,itemImg.id_vendeur,'seller')">
                                                        <div slot="error" style="text-align: center;margin-top: 40px">
                                                            <span
                                                                @click="onMenuChildClick(null,itemImg.id_vendeur,'seller')">
                                                                {{ itemImgKey }}
                                                            </span>
                                                        </div>
                                                    </el-image>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-if="itemkeys === 'AUTRES'">
                                            <p class="autres-right">{{ itemkeys }}</p>
                                            <div class="itembtn autres" v-for="(itembtn,itembtnKey) in items"
                                                 :key="itembtnKey" style="cursor: pointer"
                                                 @click="onMenuChildClick(null,itembtn,'seller')">
                                                <span>{{ itembtnKey }}</span>
                                            </div>
                                        </template>
                                    </div>
<!--                                    <div v-if="itemkeys == 'PUSH'" class="isPush">-->
<!--                                        <div v-for="(pushbtn,pushbtnKey) in items" :key="pushbtnKey">-->
<!--                                            <img v-lazy="pushbtn.img_url" alt="" class="nouv-img"-->
<!--                                                 style="width: 15vw;height: 21vw;object-fit: cover;cursor: pointer"-->
<!--                                                 @click="onMenuPushImgClick(pushbtn)">-->
<!--                                            <p>{{ pushbtnKey }}</p>-->
<!--                                        </div>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-if="mobile_menu_item_type_name==='Outlet'">
                        <div class="topOutlet">
                            <div class="vetem leftContainer">
                                <p>{{ $t("topMenuOutlet.word1") }}</p>
                                <div @click="onClickOutletRemise({prix_debut:0,prix_fin:5})">
                                    {{ $t("topMenuOutlet.word2") }}
                                </div>
                                <div @click="onClickOutletRemise({prix_debut:5,prix_fin:10})">
                                    {{ $t("topMenuOutlet.word3") }}
                                </div>
                                <div @click="onClickOutletRemise({prix_debut:10,prix_fin:15})">
                                    {{ $t("topMenuOutlet.word4") }}
                                </div>
                                <p>{{ $t("topMenuOutlet.word5") }}</p>
                                <div @click="onClickOutletRemise({promotion_debut:0,promotion_fin:30})">
                                    {{ $t("topMenuOutlet.word6") }}
                                </div>
                                <div @click="onClickOutletRemise({promotion_debut:30,promotion_fin:50})">
                                    {{ $t("topMenuOutlet.word7") }}
                                </div>
                                <div @click="onClickOutletRemise({promotion_debut:50,promotion_fin:100})">
                                    {{ $t("topMenuOutlet.word8") }}
                                </div>
                                <p>{{ $t("topMenuOutlet.word9") }}</p>
                                <p>{{ $t("topMenuOutlet.word10") }}</p>
                            </div>
                            <div class="vetem rightContainer">
                                <p>{{ $t("topMenuOutlet.word11") }}</p>
                                <div @click="onClickOutletRemise({type:11,promotion_debut:0,promotion_fin:100})">
                                    {{ $t("topMenuOutlet.word12") }}
                                </div>
                                <div @click="onClickOutletRemise({type:1103,promotion_debut:0,promotion_fin:100})">
                                    {{ $t("topMenuOutlet.word13") }}
                                </div>
                                <div @click="onClickOutletRemise({type:14,promotion_debut:0,promotion_fin:100})">
                                    {{ $t("topMenuOutlet.word14") }}
                                </div>
                                <div @click="onClickOutletRemise({type:15,promotion_debut:0,promotion_fin:100})">
                                    {{ $t("topMenuOutlet.word15") }}
                                </div>
                                <div @click="onClickOutletRemise({type:11,promotion_debut:0,promotion_fin:100})">
                                    {{ $t("topMenuOutlet.word16") }}
                                </div>
                            </div>
                            <div>
                                <FillBgBox class="bg1"
                                           :bg-img="imgs.bg1"
                                           :imgData="{jumpUrl:'/productList?prix_fin=5'}">
                                    <div>
                                        <p>{{ $t("topMenuOutlet.word17") }}</p>
                                        <span>{{ $t("topMenuOutlet.word18") }}</span>
                                    </div>
                                </FillBgBox>
                                <div style="font-size: 14pt;margin-top: 0.5vw">{{ $t("topMenuOutlet.word19") }}
                                </div>
                            </div>
                            <div style="">
                                <FillBgBox class="bg2"
                                           :bg-img="imgs.bg2"
                                           :imgData="{jumpUrl:'/productList?prix_fin=5'}">
                                    <div>
                                        <p>{{ $t("topMenuOutlet.word17") }}</p>
                                        <span>{{ $t("topMenuOutlet.word18") }}</span>
                                    </div>
                                </FillBgBox>
                                <div style="font-size: 14pt;margin-top: 0.5vw">{{ $t("topMenuOutlet.word19") }}
                                </div>
                            </div>
                        </div>
                    </template>

                    <div v-if="mobile_menu_item_type_name=='Tendances'">
                        <div class="topOutlet">
                            <div class="vetem leftContainer">
                                <p v-for="(tendance,tIndex) of tendances"
                                   :key="tIndex"
                                   @click="$router.push(`productList?tendances=${tendance.id_tendance}`)">
                                    {{ tendance.tendances_langues[0].libelle }}</p>
                            </div>
                        </div>
                    </div>
                </div>


                <!--                <el-collapse class="collapseMenu"-->
                <!--                             v-for="(type1,typeKey) in menu[category]['sub_menu']"-->
                <!--                             :key="typeKey" accordion @click="miceOver(typeKey)">-->
                <!--                    <el-collapse-item :title="getTopMenuDesc(typeKey)" :name="1">-->
                <!--                        <div v-if="typeKey==='Vêtements'">-->
                <!--                            <el-collapse class="collapseMenu"-->
                <!--                                         v-for="(items,itemkeys) in menu[category]['sub_menu'][typeKey]['sub_categorie']"-->
                <!--                                         :key="itemkeys" accordion style="">-->
                <!--                                <el-collapse-item :title="items.libelle" :name="1">-->
                <!--                                    <p class="itembtn" v-for="(itembtn,itembtnKey) in items['sub_categorie']"-->
                <!--                                       :key="itembtnKey"-->
                <!--                                       style="cursor: pointer;font-size: 14px"-->
                <!--                                       @click="onMenuChildClick(menu[category]['sub_menu'][typeKey].id_categorie,itembtn.id_categorie)">-->
                <!--                                        {{ getTopMenuDesc(itembtn.libelle) }}-->
                <!--                                    </p>-->
                <!--                                </el-collapse-item>-->
                <!--                            </el-collapse>-->
                <!--                        </div>-->
                <!--                        <div v-if="typeKey==='Accessoires'">-->
                <!--                            <el-collapse class="collapseMenu"-->
                <!--                                         v-for="(items,itemkeys) in menu[category]['sub_menu'][typeKey]"-->
                <!--                                         :key="itemkeys" accordion style="padding: 2vw">-->
                <!--                                <el-collapse-item :title="items.libelle" :name="1">-->
                <!--                                    <p class="itembtn" v-for="(itembtn,itembtnKey) in items['sub_categorie']"-->
                <!--                                       :key="itembtnKey"-->
                <!--                                       style="cursor: pointer;font-size: 14px"-->
                <!--                                       @click="onMenuChildClick(menu[category]['sub_menu'][typeKey].id_categorie,itembtn.id_categorie)">-->
                <!--                                        {{ getTopMenuDesc(itembtn.libelle) }}-->
                <!--                                    </p>-->
                <!--                                </el-collapse-item>-->
                <!--                            </el-collapse>-->
                <!--                        </div>-->
                <!--                        -->
                <!--                        <div v-if="typeKey==='Nouveautés' || typeKey==='Marques'">-->
                <!--                            <div v-for="(items,itemkeys) in menu[category]['sub_menu'][typeKey]" :key="itemkeys">-->
                <!--                                <div class="menuItem">-->
                <!--                                    <div class="menuItem_li">-->
                <!--                                        <div v-if="itemkeys!='PUSH' && typeKey==='Nouveautés'" class="noPush">-->
                <!--                                            <p>{{ getTopMenuDesc(itemkeys) }}</p>-->
                <!--                                            <div class="itembtn" v-for="(itembtn,itembtnKey) in items" :key="itembtnKey"-->
                <!--                                                 style="cursor: pointer" @click="onMenuChildClick(itembtn,null-->
                <!--                                         ,'newModel',{parentTypeKey:itemkeys})">-->
                <!--                                                {{ getTopMenuDesc(itembtnKey) }}-->
                <!--                                            </div>-->
                <!--                                        </div>-->
                <!--                                        <div v-if="typeKey==='Marques'" class="noPush Marque">-->
                <!--                                            <template v-if="itemkeys !== 'AUTRES'">-->
                <!--                                                <p>{{ getTopMenuDesc(itemkeys) }}</p>-->
                <!--                                                <div v-for="(itemImg,itemImgKey) in items" :key="itemImgKey"-->
                <!--                                                     class="imgs">-->
                <!--                                                    <img v-lazy="itemImg.logo_url" alt=""-->
                <!--                                                         style="cursor: pointer"-->
                <!--                                                         @click="onMenuChildClick(null,itemImg.id_vendeur,'seller')">-->
                <!--                                                </div>-->
                <!--                                            </template>-->
                <!--                                            <template v-if="itemkeys === 'AUTRES'">-->
                <!--                                                <p class="autres-right">{{ itemkeys }}</p>-->
                <!--                                                <div class="itembtn autres" v-for="(itembtn,itembtnKey) in items"-->
                <!--                                                     :key="itembtnKey" style="cursor: pointer"-->
                <!--                                                     @click="onMenuChildClick(null,itembtn,'seller')">-->
                <!--                                                    <span>{{ itembtnKey }}</span>-->
                <!--                                                </div>-->
                <!--                                            </template>-->
                <!--                                        </div>-->
                <!--                                        <div v-if="itemkeys == 'PUSH'" class="isPush">-->
                <!--                                            <div v-for="(pushbtn,pushbtnKey) in items" :key="pushbtnKey">-->
                <!--                                                <img v-lazy="pushbtn.img_url" alt="" class="nouv-img"-->
                <!--                                                     style="width: 15vw;height: 21vw;object-fit: cover;cursor: pointer"-->
                <!--                                                     @click="onMenuPushImgClick(pushbtn)">-->
                <!--                                                <p>{{ pushbtnKey }}</p>-->
                <!--                                            </div>-->
                <!--                                        </div>-->
                <!--                                    </div>-->
                <!--                                </div>-->
                <!--                            </div>-->
                <!--                        </div>-->
                <!--                        -->
                <!--                        <template v-if="typeKey==='Outlet'">-->
                <!--                            <div class="topOutlet">-->
                <!--                                <div class="vetem leftContainer">-->
                <!--                                    <p>{{ $t("topMenuOutlet.word1") }}</p>-->
                <!--                                    <div @click="onClickOutletRemise({prix_debut:0,prix_fin:5})">-->
                <!--                                        {{ $t("topMenuOutlet.word2") }}-->
                <!--                                    </div>-->
                <!--                                    <div @click="onClickOutletRemise({prix_debut:5,prix_fin:10})">-->
                <!--                                        {{ $t("topMenuOutlet.word3") }}-->
                <!--                                    </div>-->
                <!--                                    <div @click="onClickOutletRemise({prix_debut:10,prix_fin:15})">-->
                <!--                                        {{ $t("topMenuOutlet.word4") }}-->
                <!--                                    </div>-->
                <!--                                    <p>{{ $t("topMenuOutlet.word5") }}</p>-->
                <!--                                    <div @click="onClickOutletRemise({promotion_debut:0,promotion_fin:30})">-->
                <!--                                        {{ $t("topMenuOutlet.word6") }}-->
                <!--                                    </div>-->
                <!--                                    <div @click="onClickOutletRemise({promotion_debut:30,promotion_fin:50})">-->
                <!--                                        {{ $t("topMenuOutlet.word7") }}-->
                <!--                                    </div>-->
                <!--                                    <div @click="onClickOutletRemise({promotion_debut:50,promotion_fin:100})">-->
                <!--                                        {{ $t("topMenuOutlet.word8") }}-->
                <!--                                    </div>-->
                <!--                                    <p>{{ $t("topMenuOutlet.word9") }}</p>-->
                <!--                                    <p>{{ $t("topMenuOutlet.word10") }}</p>-->
                <!--                                </div>-->
                <!--                                <div class="vetem rightContainer">-->
                <!--                                    <p>{{ $t("topMenuOutlet.word11") }}</p>-->
                <!--                                    <div @click="onClickOutletRemise({type:11,promotion_debut:0,promotion_fin:100})">-->
                <!--                                        {{ $t("topMenuOutlet.word12") }}-->
                <!--                                    </div>-->
                <!--                                    <div @click="onClickOutletRemise({type:1103,promotion_debut:0,promotion_fin:100})">-->
                <!--                                        {{ $t("topMenuOutlet.word13") }}-->
                <!--                                    </div>-->
                <!--                                    <div @click="onClickOutletRemise({type:14,promotion_debut:0,promotion_fin:100})">-->
                <!--                                        {{ $t("topMenuOutlet.word14") }}-->
                <!--                                    </div>-->
                <!--                                    <div @click="onClickOutletRemise({type:15,promotion_debut:0,promotion_fin:100})">-->
                <!--                                        {{ $t("topMenuOutlet.word15") }}-->
                <!--                                    </div>-->
                <!--                                    <div @click="onClickOutletRemise({type:11,promotion_debut:0,promotion_fin:100})">-->
                <!--                                        {{ $t("topMenuOutlet.word16") }}-->
                <!--                                    </div>-->
                <!--                                </div>-->
                <!--                                <div>-->
                <!--                                    <div class="bg1">-->
                <!--                                        <div>-->
                <!--                                            <p>{{ $t("topMenuOutlet.word17") }}</p>-->
                <!--                                            <span>{{ $t("topMenuOutlet.word18") }}</span>-->
                <!--                                        </div>-->
                <!--                                    </div>-->
                <!--                                    <div style="font-size: 14pt;margin-top: 0.5vw">{{ $t("topMenuOutlet.word19") }}-->
                <!--                                    </div>-->
                <!--                                </div>-->
                <!--                                <div style="">-->
                <!--                                    <div class="bg2">-->
                <!--                                        <div>-->
                <!--                                            <p>{{ $t("topMenuOutlet.word17") }}</p>-->
                <!--                                            <span>{{ $t("topMenuOutlet.word18") }}</span>-->
                <!--                                        </div>-->
                <!--                                    </div>-->
                <!--                                    <div style="font-size: 14pt;margin-top: 0.5vw">{{ $t("topMenuOutlet.word19") }}-->
                <!--                                    </div>-->
                <!--                                </div>-->
                <!--                            </div>-->
                <!--                        </template>-->
                <!--                        -->
                <!--                        <div v-if="typeKey=='Tendances'">-->
                <!--                            <div class="topOutlet">-->
                <!--                                <div class="vetem leftContainer">-->
                <!--                                    <p v-for="(tendance,tIndex) of tendances"-->
                <!--                                       :key="tIndex"-->
                <!--                                       @click="$router.push(`productList?tendances=${tendance.id_tendance}`)">-->
                <!--                                        {{ tendance.tendances_langues[0].libelle }}</p>-->
                <!--                                </div>-->
                <!--                            </div>-->
                <!--                        </div>-->
                <!--                    </el-collapse-item>-->
                <!--                </el-collapse>-->
            </div>

            <div class="personMenu" v-if="isLogin">
                <el-dropdown class="lang" trigger="click" style="margin-right:30px" @command="langChang">
                      <span class="el-dropdown-link">
                        {{ lang_text }}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="fr">FR</el-dropdown-item>
                        <el-dropdown-item command="en">EN</el-dropdown-item>
                        <el-dropdown-item command="es">ES</el-dropdown-item>
                        <el-dropdown-item command="it">IT</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-row type="flex" align="middle" class="nav" @click.native="toFavoris">
                    <img class="icon" v-if="flag" src="@/assets/img/topMenu/Coeur.svg" alt="">
                    <img class="icon" v-else src="@/assets/img/topMenu/Coeur.svg" alt="">
                    <div class="num" v-if="notifyDataCount.fav_products_count">
                        {{ notifyDataCount.fav_products_count > 99 ? '...' : notifyDataCount.fav_products_count }}
                    </div>
                    <span class="name">Wishlist</span>
                </el-row>
                <el-row type="flex" align="middle" class="nav" @click.native="toMoncompte">
                    <img class="icon" v-if="flag" src="@/assets/img/topMenu/mine_w.svg" alt="">
                    <img class="icon" v-else src="@/assets/img/topMenu/mine.svg" alt="">
                    <span class="name">Account</span>
                </el-row>
                <el-row type="flex" align="middle" class="nav" @click.native="$router.push('/Commandes')">
                    <img class="icon" v-if="flag" src="@/assets/img/topMenu/mine_w.svg" alt="">
                    <img class="icon" v-else src="@/assets/img/topMenu/mine.svg" alt="">
                    <span class="name">{{ langPage['compte-menu']['TXT_mescommandes'] }}</span>
                </el-row>
                <el-row type="flex" align="middle" class="nav" @click.native="toPanier">
                    <img class="icon" v-if="flag" src="@/assets/img/topMenu/Bag_w.svg" alt="">
                    <img class="icon" v-else src="@/assets/img/topMenu/Bag.svg" alt="">
                    <div class="num" v-if="notifyDataCount.car_order_count">
                        {{ notifyDataCount.car_order_count > 99 ? '...' : notifyDataCount.car_order_count }}
                    </div>
                    <span class="name">{{ this.langPage[`l.general`]['TXT_monpanier'] }}</span>
                </el-row>
                <el-row v-if="$store.state.isMobile" type="flex" align="middle" class="nav"
                        @click.native="$router.push('promotions')">
                    <img class="icon" v-if="flag" src="@/assets/img/topMenu/reduce_w.svg" alt="">
                    <img class="icon" v-else src="@/assets/img/topMenu/reduce.svg" alt="">
                    <span class="name">promotions</span>
                </el-row>
                <el-row type="flex" align="middle" class="nav" @click.native="logout">
                    <span class="name">{{ this.$t("account.word1") }}</span>
                </el-row>
            </div>
        </div>
        <div v-if="mMenuFlag===2" class="mSearchContainer">
            <my-autocomplete class="search" v-model="keywords" v-on:keyup.native.enter="kwSearch"
                             :placeholder="langPage['v4-topmenu']['TXT_rechercherunproduit']" :triggerOnFocus="false"
                             :flag="`mTopMenu`"
                             :triggerOnChange="false"
                             :fetch-suggestions="kwSearch" @select="handleSelect" @showAll="showAll">
            </my-autocomplete>
        </div>
        <div v-if="mMenuFlag===3" class="menuHomeContainer">
            <div class="navList" v-if="!isLogin && isHome">
                <!--            <div class="navList" v-if="true">-->
<!--                <div class="nav" @click="goBlock('offre')">-->
<!--                    {{ langPage['v4-menu-not-connected']['TXT_offre'].toUpperCase() }}-->
<!--                </div>-->
                <div class="nav" @click="$router.push('./productList')">
                    {{ langPage['v4-menu-not-connected']['TXT_categories'].toUpperCase() }}
                </div>
<!--                <div class="nav" @click="goBlock('chiffres')">-->
<!--                    {{ langPage['v4-menu-not-connected']['TXT_chiffre'].toUpperCase() }}-->
<!--                </div>-->
<!--                <div class="nav" @click="goBlock('comment')">-->
<!--                    {{ langPage['v4-menu-not-connected']['TXT_avis'].toUpperCase() }}-->
<!--                </div>-->
<!--                <div class="nav" @click="goBlock('avis')">-->
<!--                    {{ langPage['v4-menu-not-connected']['TXT_commentcamarche'].toUpperCase() }}-->
<!--                </div>-->
<!--                <div class="nav" @click="$router.push('productList')">-->
<!--                    {{ $t('topMenuNoLogin.preview catalog').toUpperCase() }}-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
// import hoverCategor from `@/assets/source/categories`
import {Message} from "element-ui";

let commonUtils = require('../utils/common_utils');
import Login from "@/views/Login";
import FillBgBox from "@/components/fillBgBox";

export default {
    name: "topMenu",
    props: {
        flag: Boolean,
        loginFlag: Boolean,
        langKey: Number,
    },
    components: {FillBgBox, Login},
    computed: {
        lang() {
            return localStorage.getItem('lang')
        },
        isLogin() {
            return this.$store.state.userInfo.type != 'admin' && this.$store.state.token ? true : false
        },
        langPage() {
            return this.$store.state.langPage
        }
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            hoverFlag: false,
            menu: {},
            category: '',
            categoryId: this.$store.state.fast_categoryId,
            type: '',
            lang_text: 'FR',
            hoverCategor: {},
            VetementsList: [],
            AccessoiresList: [],
            imgs: {
                bg1: require("../assets/img/bg1.svg"),
                bg2: require("../assets/img/bg2.svg"),
            },
            client_imgs: this.$store.state.client_page_imgs.topMenu,
            search_categories: [
                {
                    value: this.$store.state.langPage['v4-topmenu']['TXT_toutp'],
                    label: this.$store.state.langPage['v4-topmenu']['TXT_tout']
                },
                {
                    value: this.$store.state.langPage['v4-topmenu']['TXT_nouveautesp'],
                    label: this.$store.state.langPage['v4-topmenu']['TXT_nouveautes']
                },
                {
                    value: this.$store.state.langPage['v4-topmenu']['TXT_vetementsp'],
                    label: this.$store.state.langPage['v4-topmenu']['TXT_vetements']
                },
                {
                    value: this.$store.state.langPage['v4-topmenu']['TXT_accessoires'],
                    label: this.$store.state.langPage['menu-header']['TXT_menuaccessoires']
                },
                {
                    value: this.$store.state.langPage['v4-home-not-connected']['TXT_marques'],
                    label: this.$store.state.langPage['catalogue-filtresrecherche']['TXT_vendeur']
                },
                {
                    value: this.$store.state.langPage['v4-topmenu']['TXT_decouvrirp'],
                    label: this.$store.state.langPage['v4-topmenu']['TXT_decouvrir']
                },
                {
                    value: this.$store.state.langPage['v4-topmenu']['TXT_outletp'],
                    label: this.$store.state.langPage['menu-header']['TXT_promotions']
                },
            ],
            search_category: '',
            keywords: '',
            searchData: {},
            searchData_produits: [],
            searchData_marques: [],
            notifyDataCount: {
                fav_products_count: 0,
                car_order_count: 0,
                useful_order_count: 0,
            },
            maxPayment: {},
            isHome: true,
            mMenuFlag: 0, //0什么都不显示 1登录后的菜单 2搜索的页面 3未登录的主页的菜单
            isHalfClass: false,
            isShowLoginDialog: false,
            tendances: [],
            searchIdsProd: [],//搜索的产品id
            searchIdsVendeurs: [],//搜索的产品id
            personRouterlist: [
                {
                    name: [this.$store.state['langPage']['mobile-compte']['TXT_title_1']],
                    path: "/Moncompte/Informations"
                },
                {
                    name: [this.$store.state['langPage']['v4-entreprise']['TXT_monentreprise']],
                    path: "/Moncompte/Entreprise"
                },
                {
                    name: [this.$store.state['langPage']['v4-lastthing']['TXT_mesadresses']],
                    path: "/Moncompte/Adresses"
                },
                {
                    name: [this.$store.state['langPage']['compte-menu']['TXT_mestransporteurs']],
                    path: "/Moncompte/Transporteurs"
                },
                // {
                //   name: "Mes moyens de paiement",
                //   path: "/Moncompte/Moyens"
                // },
                {
                    name: [this.$store.state['langPage']['compte-menu']['TXT_mescommandes'], this.$store.state['langPage']['v4-lastthing']['TXT_monarticles']],
                    path: "/Commandes"
                },
                {
                    name: [this.$store.state['langPage']['catalogue-filtres']['TXT_promotions']],
                    path: "/promotions"
                },
                {
                    name: [this.$t("account.word1")],
                    path: "/"
                }
            ],
            mobile_menu_item_type_name: null,//要显示的移动端二级菜单 null的时候显示一级菜单，其他名字的时候显示对应名字的二级菜单
        }
    },
    created() {
        let langs = localStorage.getItem('lang') || 'fr'
        if (langs) this.lang_text = langs.toLocaleUpperCase()
        this.hoverCategor = require(`../assets/source/categories.${langs.toLocaleLowerCase()}.json`)
        this.setAppClass();
        // this.filterVeteme()
        // this.filterAccess()
        // console.log(this.hoverCategor)
    },
    mounted() {
        if (this._isMobile()) {
            // this.$router.replace('/downloadApp');
            this.getTendances();
        }
        // this.$api.menu.getMenuProduits(11).then(data => {
        //     console.log('Produits', data)
        // })
        // this.$api.menu.getMenuVendeurs(11).then(data => {
        //     console.log('Vendeurs', data)
        // })
        this.isHome = this.$route.path === '/';
        console.log('缓存菜单', this.$store.state.menu)
        this.menu = this.$store.state.menu;//先使用缓存的菜单，等获取到新菜单再用新的
        this.$api.menu.getTopmenu({id_langue: this.lang}).then(data => {
            console.log(data)
            this.$store.commit('set', {key: 'menu', value: data.result.data})
            this.menu = this.$store.state.menu;
            let menuKeys = Object.keys(this.menu);
            for (let key of menuKeys) {
                let valueMenu = this.menu[key];
                if (valueMenu.id_categorie == this.$store.state.fast_categoryId) {
                    this.category = key;
                }
            }
        });
        if (this.isLogin) {
            this.$api.info.getInfo().then(res => {
                if (res.acheteur) {
                    this.$store.commit('set', {key: 'userInfo', value: res.acheteur});
                }
            })
            this.$api.info.getV2Info().then(res => {
                if (res.code === 0) {
                    this.notifyDataCount = res.data.notifyDataCount;
                    this.maxPayment = res.data.maxPayment;
                }
            })
        }
        this.replaceClientImgs();
    },
    methods: {
        categorys(cateKey, para) {
            this.category = cateKey
            this.categoryId = parseInt(para.id_categorie)
            // localStorage.setItem('fast_category_id', this.categoryId)
            this.$store.commit('set', {key: 'fast_categoryId', value: this.categoryId})
            this.$store.commit('set', {key: 'fast_category_name', value: this.category});
            window.location.reload()
        },
        langChang(command) {
            this.lang_text = command.toLocaleUpperCase()
            localStorage.setItem('lang', command)
            let langJson = require(`../assets/source/langV4/langv4.${this.lang_text.toLocaleLowerCase()}.json`)
            this.$store.commit('set', {key: 'langPage', value: langJson})
            this.$store.commit('set', {key: 'lang', value: command})
            // this.$api.menu.getLang({id_langue:command}).then(data=>{
            //     this.$store.commit('set',{key:'langPage',value:data})
            // })
            this.$i18n.locale = command
            window.location.reload()
            // this.langKey++
        },
        goBlock(el) {
            this.$common.EventBus.$emit('goBlock', el)
        },
        miceOver(key) {
            this.hoverFlag = true
            this.type = key
        },
        miceLeave() {
            this.hoverFlag = false
        },
        toFavoris() {
            this.$router.push({name: 'favoris'})
        },
        toMoncompte() {
            this.$router.push({name: 'Moncompte'})
        },
        toPanier() {
            this.$router.push({name: 'Panier'})
        },
        //顶部菜单的产品列表下拉的子项被点击了
        onMenuChildClick(modelTypeId, categoriesId, type = 'productList', obj) {
            //type 'newModel'新品模块, 'productList'产品列表,'seller'是商家图标。不同的跳完不同的链接
            console.log(modelTypeId)
            if (type === 'newModel') {
                if (obj.parentTypeKey === 'NOUVEAUX VENDEURS') {
                    this.onMenuChildClick(null, modelTypeId, 'seller')
                } else this.onClickNewSeeMore(obj.parentTypeKey, modelTypeId)
            } else if (type === 'productList') {
                this.$router.push(`/productList?id=${categoriesId}`)
            } else if (type === 'seller') {
                let newPage = this.$router.resolve({path: `/vendeur/${categoriesId}`})//这里的categoriesId是商家id
                window.open(newPage.href, '_blank')
            }
            console.log(modelTypeId, categoriesId);
        },
        onTopLogoClick() {
            this.$router.replace('/homepage');
        },
        //菜单栏里面Nouveautés的右边图片被点击
        onMenuPushImgClick(item) {
            let vid = commonUtils.getCenterStr(item.img_url, 'Boutiques/', '/Produits');
            this.$router.push({path: '/ProductDetail', query: {id: item.id_produit, vid: vid}})
        },
        //点击搜索产品
        kwSearch(queryString, cb) {
            let query = {
                id_langue: this.$store.state["lang"] ? this.$store.state["lang"] : "fr",
                keywords: this.keywords,
            };
            if (this.search_category) {
                query.type = this.search_category;
            }
            this.$api.good.search(query).then(res => {
                if (res.code === 0) {
                    this.searchData = res.data;
                    this.searchData_produits = this.searchData.produits;
                    this.searchData_marques = this.searchData.marques;
                    this.searchIdsProd = [];
                    this.searchIdsVendeurs = [];

                    this.searchData_produits.forEach(prod => {
                        prod.value = prod.reference;
                        prod.search_type = 'produit';
                        this.searchIdsProd.push(prod.id_produit);
                    })
                    this.searchData_marques.forEach(marque => {
                        marque.value = marque.nom_marque;
                        marque.search_type = 'marque';
                        this.searchIdsVendeurs.push(marque.id_vendeur);
                    })
                    let results = [
                        {title: 'produit', list: this.searchData_produits,},
                        {title: 'marques', list: this.searchData_marques,},
                    ]
                    cb(results);
                }
            });
            if (this.keywords) {
                let body = {
                    libelle: this.keywords,
                    link: 'http://www.baidu.com',
                    id_langue: this.$store.state.lang
                };
                this.$api.good.addTrackSearch(body).then(res => {
                });
            }
        },
        //用户点击了他所搜索的产品
        handleSelect(item) {
            console.log('handleSelect', item);
            if (item.search_type === 'produit') {
                this.$router.push(`/ProductDetail?id=${item.id_produit}&vendu_par=${item.vendu_par}&vid=${item.id_vendeur}&categorie_id=${item.id_categorie}`);
            } else if (item.search_type === 'marque') {
                this.$router.push(`/vendeur/${item.id_vendeur}`);
            }
        },
        onClickOutletRemise(item) {
            let type = item.type;
            let url = `/ProductList`;
            if (type) url += `/${type}`;
            let params = '';
            if (item.promotion_debut || item.promotion_debut === 0) params += `&promotion_debut=${item.promotion_debut}`;
            if (item.promotion_fin) params += `&promotion_fin=${item.promotion_fin}`;
            if (item.prix_debut || item.prix_debut === 0) params += `&prix_debut=${item.prix_debut}`;
            if (item.prix_fin) params += `&prix_fin=${item.prix_fin}`;
            if (params) params = '?' + params.substring(1);
            window.location.href = window.origin + `${url}${params}`;
        },
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            this.$store.commit('set', {key: 'isMobile', value: flag});
            return flag;
        },
        //当点击了移动端的菜单的按钮
        onClickMenuOrCloseBtn() {
            if (this.mMenuFlag !== 0) {
                return this.mMenuFlag = 0;
            } else if (this.isLogin) {
                return this.mMenuFlag = 1;
            } else if (!this.isLogin && this.isHome) {
                return this.mMenuFlag = 1;
            }
            return this.mMenuFlag = 1;
        },
        //获取菜单的一些单词翻译
        getTopMenuDesc(typeKey) {
            try {
                let keys = Object.keys(this.$t(`topMenuDesc`));
                if (typeKey === "AJOURD'HUI") {
                    typeKey = "AJOURD HUI";
                }
                if (!keys.includes(typeKey)) return typeKey;
                return this.$t(`topMenuDesc.${typeKey}`);
            } catch (e) {
                return '' + e;
            }
        },
        //顶部分类菜单的按钮点击
        categoryMenuClick(typeKey) {
            switch (typeKey) {
                case 'Accessoires':
                    window.location.href = window.origin + `/productList?id=16`;
                    break;
                case 'Marques':
                    window.location.href = window.origin + '/marquesList';
                    break;
                case 'Nouveautés':
                    window.location.href = window.origin + `/Nouveautes/${this.menu[this.category]['id_categorie']}`;
                    break;
                case 'Outlet':
                    this.onClickOutletRemise({
                        type: this.menu[this.category]['id_categorie'],
                        promotion_debut: 0,
                        promotion_fin: 100
                    })
                    break;
                case 'Vêtements':
                    window.location.href = window.origin + `/productList?id=${this.menu[this.category]['id_categorie']}`;
                    break;
                case 'Tendances':
                    this.$router.push(`/tendances`);
                    break;
            }
        },
        //转化菜单的keyNa
        convertMenuKeyName() {

        },
        // 设置不同的appContainer的class
        setAppClass() {
            // this.isHalfClass = ['/','/homepage','/about' ].includes(this.$route.path) && !this.isMobile;
            this.isHalfClass = !this.isMobile;
        },
        //点击了查看新品更多的按钮
        onClickNewSeeMore(itemKey, category = '11') {
            console.log(itemKey, category);
            let date_creation_debut = null;
            switch (itemKey) {
                case `AJOURD'HUI`:
                    date_creation_debut = (new Date(Date.now() - (24 * 60 * 60 * 1000))).format('yyyy-MM-dd');
                    this.$router.push(`/Nouveautes/${category}?date_creation_debut=${date_creation_debut}`);
                    break;
                case `CETTE SEMAINE`:
                    date_creation_debut = (new Date(Date.now() - (24 * 60 * 60 * 1000 * 7))).format('yyyy-MM-dd');
                    this.$router.push(`/Nouveautes/${category}?date_creation_debut=${date_creation_debut}`);
                    break;
                case `NOUVEAUX VENDEURS`:
                    this.$router.push('/marquesList');
                    break;
            }
        },
        async getTendances() {
            if (!this.isLogin) return;
            let res = await this.$api.good.get_tendances();
            if (res.code != 0) return;
            this.tendances = res.data;
        },
        //查看所有的产品
        showAll() {
            if (commonUtils.isEmpty(this.searchIdsVendeurs)
                && commonUtils.isEmpty(this.searchIdsProd)) Message.error('search is empty');
            window.location.href = `/productList?vendeurs=${this.searchIdsVendeurs}&produits=${this.searchIdsProd}&searchWord=${this.keywords}`;
        },
        async onPersonMenuItemClick(item) {
            if (item.name[0] === this.$t("account.word1")) {
                this.logout();
            } else {
                this.$router.push(item.path);
            }
        },
        async logout() {
            localStorage.clear();
            this.$store.commit('set', {key: 'token', value: ''});
            window.document.cookie = '';
            commonUtils.delCookie('acheteurlogin');
            this.$router.replace({path: '/'})
        },
        //点击了减免便宜价格的图片
        async onClickDiscountImg() {
            this.$router.push('/productList?prix_fin=5');
        },
        //替换客户端图片
        replaceClientImgs() {
            console.log('client_imgs', this.client_imgs,)
            let clientImgs = this.client_imgs;
            if (Object.keys(clientImgs).length == 0) return;
            for (let key of Object.keys(this.imgs)) {
                this.imgs[key] = clientImgs[key].file_url;
            }
            console.log('client_imgs2', this.imgs)
            this.$forceUpdate();
        },
        //点击移动端的
        onClickMobileMenuSubTitle(typeKey) {
            if (typeKey == 'Marques') {
                this.$router.push('/MarquesList');
            } else {
                this.mobile_menu_item_type_name = typeKey;
            }
        },
        onClickLogin() {
            // this.isShowLoginDialog = true;
            let redirect = encodeURIComponent(this.$route.fullPath);
            this.$router.push(`/login?redirect=${redirect}`);
        }
    },
}
</script>

<style scoped lang="less">
.topMenu {
    position: relative;
    overflow: visible;

    &.in {
        min-height: .6rem;
        position: absolute;
        top: 0;
        z-index: 1;
        width: 100%;
    }

    &.out {
        min-height: .6rem;
        position: relative;
    }

    &.halfWidth {
        @media only screen and (min-width: 1440px) {
            width: 1440px;
        }
    }

    box-sizing: content-box;

    .menu {
        padding: 10px 64px 20px;
        min-height: .4rem;
        position: relative;
        width: 100%;

        &.black {
            color: #000;

            a {
                color: #000;
            }

            .lang {
                color: #000;

                .el-dropdown-link {
                    i {
                        color: #000;
                    }
                }

            }
        }

        &.white {
            color: #FFFFFF;

            a {
                color: #FFFFFF;
            }

            .lang {
                color: #FFFFFF;

                .el-dropdown-link {
                    i {
                        color: #FFFFFF;
                    }
                }
            }
        }

        .navList {
            display: inline-block;
            width: 50%;
            height: .33rem;
            line-height: .33rem;
            vertical-align: top;

            .nav {
                font-family: MaisonNeue-Medium;
                display: inline-block;
                margin-right: 30px;
                font-size: 14px;
                /*line-height: .16rem;*/
                /*height: .16rem;*/
                cursor: pointer;
                position: relative;
                overflow: visible;

                &.child {
                    font-family: MaisonNeue-Light;
                }

                &.act {
                    text-decoration-line: underline;
                }

                .icon {
                    width: 22.5px;
                    vertical-align: middle;
                }

                .num {
                    position: absolute;
                    top: 0;
                    right: -.1rem;
                    font-size: 0.095rem;
                    font-weight: bold;
                    height: 1.1vw;
                    width: 1.1vw;
                    text-align: center;
                    line-height: .17rem;
                    border-radius: 2rem;
                    font-family: MaisonNeue-Medium;
                    color: #fff;
                    background-color: #000;
                }

                .childs {
                    font-family: "MaisonNeue-Light";
                    display: inline-block;
                    font-size: 14px;
                    /*line-height: .16rem;*/
                    /*height: .16rem;*/
                    cursor: pointer;
                    position: relative;
                    overflow: visible;

                }

                .childs:hover {
                    text-decoration-line: underline;
                }
            }

            .lang {
                vertical-align: top;
            }

            .search {
                display: inline-block;
                width: 280px;
                float: right;
                height: .4rem;

                .el-input__icon {
                    font-size: 0.16rem;
                    line-height: 20px;
                }
            }

        }

        .navListHome {
            display: inline-block;
            width: 47%;
            margin-right: 3%;
            height: .33rem;
            line-height: .33rem;
            vertical-align: top;

            .nav {
                font-family: MaisonNeue-Medium;
                display: inline-block;
                margin-right: 15px;
                font-size: 14px;
                /*line-height: .16rem;*/
                /*height: .16rem;*/
                cursor: pointer;
                position: relative;
                overflow: visible;
            }
        }

        .logo {
            position: absolute;
            width: 117px;
            left: 50%;
            margin-left: -.55rem;
            margin-top: 0.045rem;
        }

        .searchContainer {
            position: absolute;
            right: 0;
            vertical-align: baseline;

            .el-select {
                border: none !important;
            }

            .el-select /deep/ .el-input {
                border: none !important;
                border-color: #fff;
            }

            .el-select /deep/ input {
                border: none !important;
                font-size: 14px;
            }

            .el-select /deep/ input::placeholder {
                color: black;
            }

            .selectBox {
                width: 10vw;
                padding-right: 0;
                margin-right: 0;

                .placeHolder {
                    margin-left: 20px;
                    font-size: 122pt;
                }
            }
        }
    }

    .topOutlet {
        display: flex;
        flex-wrap: wrap;
        position: relative;
        width: 100%;
        height: 20vw;

        .leftContainer {
        }

        .rightContainer {
            margin-left: 5vw;
        }

        .bg1 {
            height: 20vw;
            width: 15vw;
            background-size: cover;
            text-align: center;
            cursor: pointer;

            div {
                padding-top: 50%
            }

            p {
                font-size: 0.13rem
            }

            span {
                font-size: 0.4rem
            }
        }

        .bg2 {
            height: 20vw;
            width: 15vw;
            background-size: cover;
            text-align: center;
            cursor: pointer;

            div {
                padding-top: 50%
            }

            p {
                font-size: 0.13rem
            }

            span {
                font-size: 0.4rem
            }
        }
    }

    .listMenu {
        position: absolute;
        padding: 10px .5rem 0.27rem;
        margin-top: 15px;
        background-color: #F6F3F1;
        top: .8rem;
        width: 100%;
        z-index: 10;
        min-height: 1rem;

        .menuCont {
            display: flex;
            justify-content: space-between;

            .menuItem {
                &_li {
                    // margin-right: 64px;
                    .noPush {
                        p {
                            font-family: MaisonNeue-Bold;
                            margin-bottom: 14px;
                            font-size: 14px;
                        }

                        > div {
                            font-family: MaisonNeue-Light;
                            margin-bottom: 14px;
                            font-size: 14px;
                        }

                        > div:hover {
                            text-decoration: underline;
                        }

                        .imgs {
                            width: 192px;
                            height: 111px;
                            display: inline-block;
                            margin: 0 16px;

                            img {
                                width: 192px;
                                height: 111px;
                                display: block;
                            }

                            .img2 {
                                width: 192px;
                                height: 111px;
                                display: block;
                            }
                        }
                    }

                    .tout {
                        cursor: pointer;
                    }

                    .Marque {
                        min-width: 800px;
                        width: 900px;

                        .autres {
                            margin-left: 144px;
                        }

                        .autres-right {
                            margin-left: 144px;
                        }

                        .tout {
                            margin-left: 144px;
                            cursor: pointer;
                        }
                    }

                    .isPush {
                        display: flex;
                        justify-content: right;

                        > div {
                            margin-left: 32px;

                            p {
                                font-family: MaisonNeue-Bold;
                                font-size: 14px;
                                margin-top: 0.06rem;
                            }

                            img {
                                // width: 304px;
                                // height: 380px;
                                display: block;
                            }

                            .nouv-img {
                                width: 304px;
                                height: 380px;
                            }
                        }
                    }
                }
            }

            .vetem {
                p {
                    font-family: MaisonNeue-Bold;
                    margin-bottom: 14px;
                    font-size: 14px;
                }

                p:hover {
                    text-decoration: underline;
                }

                > div {
                    cursor: pointer;
                    font-family: MaisonNeue-Light;
                    margin-bottom: 14px;
                    font-size: 14px;
                }

                div:hover {
                    text-decoration: underline;
                }

                .imgs {
                    width: 192px;
                    height: 111px;
                    display: inline-block;
                    margin: 0 16px;

                    img {
                        width: 192px;
                        height: 111px;
                        display: block;
                    }
                }
            }

            .vetem-push {
                p {
                    font-family: MaisonNeue-Bold;
                    font-size: 14px;
                    margin-top: 0.06rem;
                }
            }
        }
    }

    .shadow {
        //width: 100%;
        height: 1px;
        box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.1);
        margin-bottom: 10px;
        margin-top: 16px;
        //position: absolute;
        //display: flex;
        //flex-grow: 1;
        //left: 0;
        width: calc(100% + 128px);
        margin-left: -64px;
    }

    /deep/ .el-dialog {
        width: 0%;
        height: 80%;
    }
}

.mTopMenu {
    .content {
        display: flex;
        position: relative;
        height: 13vw;
        padding: 0 24px;

        .leftMenu {
            width: 4.8vw;
            height: 4.8vw;
        }

        .centerLogoIcon {
            position: absolute;
            width: 25vw;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }

        .rightMenu {
            display: flex;

            .rightSearch {
                font-size: 10pt;
                width: 4.8vw;
                height: 4.8vw;
                margin-right: 5vw;
            }

            .rightShopCar {
                width: 4.8vw;
                height: 4.8vw;
            }

            .icon {
                width: 4.8vw;
                height: 4.8vw;
            }

            .lang {
                margin-left: 2vw;
                color: #000;

                .el-dropdown-link {
                    i {
                        color: #000;
                    }
                }

            }
        }
    }

    .menuDetailContainer {
        width: 100vw;
        min-height: 100vh;
        display: inline-block;
        position: absolute;
        z-index: 10;
        background-color: #F6F3F1;
        padding: 6.4vw 24px;

        .collapseTopMenu {
            height: 20px;
            display: flex;
            align-items: center;

            .title {

            }

            .itembtn {
                padding: 5px 0;
            }
        }

        .collapseMenu {
            .itembtn {
                padding: 5px 0;
            }
        }

        .subMenuBox {
            margin: 10px 0;
        }

        .navList {
            display: flex;
            width: 100%;
            margin-bottom: 7vw;

            .nav {
                margin-right: 10vw;
                font-family: "MaisonNeue-Light";
                display: inline-block;
                font-size: 10pt;
                cursor: pointer;
                position: relative;
                overflow: visible;

                &.child {
                    font-family: MaisonNeue-Light;
                }

                &.act {
                    text-decoration-line: underline;
                }
            }
        }

        .menuItem {
            &_li {
                // margin-right: 64px;
                .noPush {
                    p {
                        font-family: MaisonNeue-Bold;
                        margin-bottom: 14px;
                        font-size: 8pt;
                    }

                    > div {
                        font-family: MaisonNeue-Light;
                        margin-bottom: 18px;
                        font-size: 8pt;
                    }

                    .imgsBox {
                        display: flex;
                        flex-wrap: wrap;
                        width: 100vw;

                        .imgs {
                            //display: inline-block;
                            margin: 5px 8px;

                            img {
                                width: 40vw;
                                height: 20vw;
                                display: block;
                            }
                        }
                    }

                }

                .Marque {
                    min-width: 800px;
                    width: 900px;

                    .autres {
                        margin-left: 3vw;
                    }

                    .autres-right {
                    }

                    .tout {
                        margin-left: 144px;
                        cursor: pointer;
                    }
                }

                .isPush {
                    display: flex;
                    justify-content: right;

                    > div {
                        margin-left: 32px;

                        p {
                            font-family: MaisonNeue-Bold;
                            font-size: 8pt;
                            margin-top: 1vw;
                        }

                        img {
                            // width: 304px;
                            // height: 380px;
                            display: block;
                        }

                        .nouv-img {
                            width: 304px;
                            height: 380px;
                        }
                    }
                }
            }
        }

        .vetem {
            p {
                font-family: MaisonNeue-Bold;
                margin-bottom: 14px;
                font-size: 8pt;
            }

            > div {
                cursor: pointer;
                font-family: MaisonNeue-Light;
                margin-bottom: 14px;
                font-size: 8pt;
            }

            .imgs {
                width: 192px;
                height: 111px;
                display: inline-block;
                margin: 0 16px;

                img {
                    width: 192px;
                    height: 111px;
                    display: block;
                }
            }
        }

        .vetem-push {
            p {
                font-family: MaisonNeue-Bold;
                font-size: 8pt;
                margin-top: 1vw;
            }
        }

        .topOutlet {

            .bg1 {
                height: 90vw;
                width: 60vw;
                background-size: cover;
                text-align: center;
                cursor: pointer;

                div {
                    padding-top: 50%
                }

                p {
                    font-size: 14pt
                }

                span {
                    font-size: 80pt
                }
            }

            .bg2 {
                height: 90vw;
                width: 60vw;
                background-size: cover;
                text-align: center;
                cursor: pointer;

                div {
                    padding-top: 50%
                }

                p {
                    font-size: 14pt
                }

                span {
                    font-size: 80pt
                }
            }
        }

        .personMenu {
            width: 100%;
            margin-top: 3vw;

            .nav {
                margin-right: 10vw;
                margin-top: 8vw;
                font-family: "MaisonNeue-Light";
                font-size: 10pt;
                cursor: pointer;
                position: relative;

                .icon {
                    width: 5vw;
                }

                .num {
                    position: absolute;
                    top: -1.3vw;
                    left: 3vw;
                    padding-top: 2px;
                    font-size: 8pt;
                    height: 4.2vw;
                    width: 4.2vw;
                    text-align: center;
                    color: #fff;
                    background-color: #000;
                    border-radius: 100vw;
                }

                .name {
                    margin-left: 5vw;
                    font-size: 10pt;
                    font-weight: bold;
                }

                .childs {
                    font-family: "MaisonNeue-Light";
                    display: inline-block;
                    font-size: 12pt;
                    cursor: pointer;
                    position: relative;
                    overflow: visible;
                }
            }
        }

        .search {
            /*display: inline-block;*/
            /*width: 20vw;*/
            /*float: right;*/
            /*height: .4rem;*/

            /*.el-input__icon {*/
            /*    font-size: 0.16rem;*/
            /*    line-height: 20px;*/
            /*}*/
        }
    }

    .mSearchContainer {
        width: 100vw;
        min-height: 100vh;
        display: inline-block;
        position: absolute;
        z-index: 10;
        background-color: white;

        .search {
            width: 100%;
        }
    }

    .menuHomeContainer {
        display: inline-block;
        position: absolute;
        z-index: 10;
        background-color: white;
        padding: 3vw 3vw 0 3vw;

        .navList {
            width: 100%;

            .nav {
                margin-right: 10vw;
                font-family: "MaisonNeue-Light";
                font-size: 10pt;
                cursor: pointer;
                font-weight: bold;
                margin-bottom: 3vw;

                &.child {
                    font-family: MaisonNeue-Light;
                }

                &.act {
                    text-decoration-line: underline;
                }
            }
        }
    }
}
</style>
